import { ReactNode } from 'react';
import { css } from '@emotion/react';
import { breakpoints } from '@frontend/responsiveness';
import { theme } from '@frontend/theme';

type Props = {
  children: ReactNode;
  onClick?: () => void;
};

export const ContentPanelHeaderBar = ({ children, onClick, ...rest }: Props) => {
  return (
    <header
      css={css`
        align-items: center;
        border-bottom: 1px solid ${theme.colors.neutral20};
        display: flex;
        padding: ${theme.spacing(3, 3, 2, 3)};
        justify-content: space-between;
        @media screen and (max-width: ${breakpoints.small.min}px) {
          h1 {
            font-size: ${theme.fontSize(24)};
          }
        }
      `}
      onClick={onClick}
      {...rest}
    >
      {children}
    </header>
  );
};
